export default "__VITE_ASSET__Drz0dpSr__"